import { useContext } from "react";
import { useIntl } from "react-intl";
import { AppContext, AppContextInterface } from "@/contexts/AppContext";
import { AiSuggestedQuestions } from "../AiSuggestedQuestions";

const DEFAULT_QUESTION_IDS = [
  "app.toolboxChat.intro.question1",
  "app.toolboxChat.intro.question2",
  "app.toolboxChat.intro.question3",
] as const;

interface ChatIntroPanelProps {
  onQuestionSelected: (question: string) => void;
}

export const ChatIntroPanel = ({ onQuestionSelected }: ChatIntroPanelProps) => {
  const intl = useIntl();
  const { sysUser } = useContext<AppContextInterface>(AppContext);
  const defaultQuestions = DEFAULT_QUESTION_IDS.map((id) => intl.formatMessage({ id }));

  return (
    <div className="tcw-intro">
      <h3 className="tcw-intro-title">
        <span className="tcw-intro-title__name">
          {intl.formatMessage(
            { id: "app.toolboxChat.intro.greetingName" },
            { firstName: sysUser?.firstName },
          )}
        </span>{" "}
        {intl.formatMessage({ id: "app.toolboxChat.intro.greetingBody" })}
      </h3>
      <hr className="tcw-intro-divider" />
      <p className="tcw-intro-body">
        {intl.formatMessage({ id: "app.toolboxChat.intro.body" })}
      </p>
      <p className="tcw-intro-prompt">
        {intl.formatMessage({ id: "app.toolboxChat.intro.prompt" })}
      </p>
      <AiSuggestedQuestions
        questions={defaultQuestions}
        onQuestionSelected={onQuestionSelected}
      />
    </div>
  );
};
